import { SubscriptionDeliveryCount } from "./SubscriptionDeliveryCount.js";
import { SubscriptionSelection } from "./SubscriptionSelection.js";
import { SubscriptionSize } from "./SubscriptionSize.js";

// FCR-522: Fixed gift subscription prices without tax in CZK, taken from the "PŘEDPLATNÉ - fixní CZ" pricing sheet.
// Already include the Father's Family discount, so no further discount is applied on top.
const giftSubscriptionPriceTable: Record<
	SubscriptionSelection,
	Record<SubscriptionSize, Record<SubscriptionDeliveryCount, number>>
> = {
	[SubscriptionSelection.Cafeina]: {
		[SubscriptionSize.G250]: {
			[SubscriptionDeliveryCount.Deliveries3]: 803,
			[SubscriptionDeliveryCount.Deliveries6]: 1606,
			[SubscriptionDeliveryCount.Deliveries12]: 3213,
		},
		[SubscriptionSize.G250x2]: {
			[SubscriptionDeliveryCount.Deliveries3]: 1446,
			[SubscriptionDeliveryCount.Deliveries6]: 2891,
			[SubscriptionDeliveryCount.Deliveries12]: 5783,
		},
		[SubscriptionSize.Kg1]: {
			[SubscriptionDeliveryCount.Deliveries3]: 2793,
			[SubscriptionDeliveryCount.Deliveries6]: 5586,
			[SubscriptionDeliveryCount.Deliveries12]: 11172,
		},
	},
	[SubscriptionSelection.MothersBlend]: {
		[SubscriptionSize.G250]: {
			[SubscriptionDeliveryCount.Deliveries3]: 870,
			[SubscriptionDeliveryCount.Deliveries6]: 1740,
			[SubscriptionDeliveryCount.Deliveries12]: 3480,
		},
		[SubscriptionSize.G250x2]: {
			[SubscriptionDeliveryCount.Deliveries3]: 1566,
			[SubscriptionDeliveryCount.Deliveries6]: 3132,
			[SubscriptionDeliveryCount.Deliveries12]: 6264,
		},
		[SubscriptionSize.Kg1]: {
			[SubscriptionDeliveryCount.Deliveries3]: 3027,
			[SubscriptionDeliveryCount.Deliveries6]: 6054,
			[SubscriptionDeliveryCount.Deliveries12]: 12108,
		},
	},
	[SubscriptionSelection.FathersChoice]: {
		[SubscriptionSize.G250]: {
			[SubscriptionDeliveryCount.Deliveries3]: 1077,
			[SubscriptionDeliveryCount.Deliveries6]: 2154,
			[SubscriptionDeliveryCount.Deliveries12]: 4308,
		},
		[SubscriptionSize.G250x2]: {
			[SubscriptionDeliveryCount.Deliveries3]: 1939,
			[SubscriptionDeliveryCount.Deliveries6]: 3877,
			[SubscriptionDeliveryCount.Deliveries12]: 7754,
		},
		[SubscriptionSize.Kg1]: {
			[SubscriptionDeliveryCount.Deliveries3]: 3714,
			[SubscriptionDeliveryCount.Deliveries6]: 7428,
			[SubscriptionDeliveryCount.Deliveries12]: 14856,
		},
	},
};

/**
 * Returns the fixed gift subscription price without tax in CZK for the given coffee selection, size and delivery count.
 */
export function getGiftSubscriptionPrice(
	selection: SubscriptionSelection,
	size: SubscriptionSize,
	deliveryCount: SubscriptionDeliveryCount,
): number {
	return giftSubscriptionPriceTable[selection][size][deliveryCount];
}
